<template>
    <div name="navigation" class="navigation" >
        <div class="header">
            <div class="logo-area">
                <img class="logo" src="../../assets/basic/pc/logo.png" alt="soldoc+"/>
                <img class="logo-blue" src="../../assets/pc_barocare/logo_blue.png" alt="soldoc+"/>
            </div>
            <div class="btn-area">
                <a href="#barocareStory" class="btn-outline-white"  @click="scrollToStory">제휴 신청하기</a>
            </div>
        </div>       
    </div>
</template>

<script>
export default {
    name: 'navigation',
    data() {
    return {
        };
    },
    mounted: function()
    {

        $(window).scroll(function() {
            updateNav();
        });

        function updateNav() {
            var vhHeight = window.innerHeight / 100;
            var oneVh = 100 * vhHeight;
            var oneVhHeight = 100 * vhHeight - 500;
            var threeVhHeight = 300 * vhHeight - oneVh;
            var height = $(document).scrollTop();

            if (height >= oneVhHeight && height < oneVhHeight) {
                $('.navigation').css('position', 'fixed');
            } 
            else if (height >= oneVhHeight) {
                $('.navigation').css('position', 'absolute');
            }
        }
    },
    methods: {
        goSign: function()
        {
            window.open('https://partner.soldoc.co.kr/', '_blank')
        },
        scrollToStory() {
            var element = document.getElementById("barocareStory");
            if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            }
        },
    }
}
</script>

<style scoped>
    .navigation {
        position: absolute;
        position: fixed;
        top:0;
        width: 100%;
        height: 105px;
        /* background: #555; */
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        z-index: 100;
    }
    .header {
        display: flex;
        width: 100%;
        padding: 0 17px 0 27px;
        height: 34px;
        margin-top: 24px;
        justify-content: space-between;
        align-items: center;
    }
    .logo-area{
        width: 79.2px;
        margin-top: -5px;
    }
    .logo-area img{
        width: 100%;
    }
    .logo-blue{
        display: none;
    }
    .btn-outline-white{
        display: inline-flex;
        width: 106px;
        min-height: 34px;
        padding: 8px 19px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #fff;
        background: rgba(0, 0, 0, 0.10);
        color: #FFF;
        text-align: center;
        font-size: 12px;
        font-family: 'Pretendard';
        font-weight: 400;
        line-height: 1.3;
        cursor: pointer;
        text-decoration: none; 
    }
    .btn-outline-white:hover{
        background: #FFF;
        color: #0082EC;
        font-weight: 600;
        text-decoration: none; 
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/Navigation.vue